import { OrderAdapter } from "../adapters/order-adapter";
import { httpClient } from "../http-client/base-client";
import {
  ApiCreateOrder,
  ApiCreateOrderResponse,
  ApiOrder,
  ApiOrderOptions,
} from "../types/order/api-types";

export const OrderResource = {
  async getOptions(): Promise<ApiOrderOptions> {
    const order = await httpClient.get<ApiOrderOptions>("order");
    return order;
  },

  async createOrder(order: ApiCreateOrder): Promise<ApiCreateOrderResponse> {
    const apiOrder = await httpClient.post<ApiCreateOrderResponse>(
      "order/create",
      order,
    );
    return apiOrder;
  },

  async confirmOrder(query: string): Promise<void> {
    await httpClient.post(`order/confirm?${query}`);
  },
};
